import * as React from 'react';

import {RouteContext} from '../route-context';

type Props = {
    default: React.ReactNode;
    embedded: React.ReactNode;
};

export function Embedded(props: Props) {
    const {isEmbedded} = React.useContext(RouteContext);

    return isEmbedded ? props.embedded : props.default;
}
